import { useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import AuthLayout from "./AuthLayout";
import Field from "./components/Field";
import Button from "./components/Button";
import Stack from "./components/Stack";
import { createUser } from "./api";

const handleUserRegister = async (uname, pwd, email1, number) => {
  try {
    const response = await createUser({
      username: uname,
      password: pwd,
      user_type: "User",
      email: email1,
      u_phoneno: number,
    });
    if (response.data.message === "registered") return 1;
    if (response.data.message === "Unique") return 2;
    return 3;
  } catch (error) {
    if (error.response && (error.response.status === 409 || error.response.data?.message === "Unique")) {
      return 2;
    }
    return 3;
  }
};

export default function Register() {
  const history = useHistory();
  const [uname, setuname] = useState("");
  const [pwd, setpwd] = useState("");
  const [cnfrmpwd, setcnfrmpwd] = useState("");
  const [email1, setemail1] = useState("");
  const [number, setnumber] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    if (uname.length <= 4 || pwd.length <= 4) {
      toast.error("Username and password must be at least 5 characters.");
      return;
    }
    if (cnfrmpwd !== pwd) {
      toast.error("Passwords don't match.");
      return;
    }
    if (number.length <= 9 || email1.length === 0) {
      toast.error("Email or phone number cannot be empty.");
      return;
    }
    const result = await handleUserRegister(uname, pwd, email1, number);
    if (result === 1) {
      toast.success("Registration successful! Please log in.");
      history.push("/login");
    } else if (result === 2) {
      toast.error("Username taken. Try another.");
    } else {
      toast.error("Registration unsuccessful. Try again.");
    }
  };

  return (
    <AuthLayout title="Create your account" subtitle="Join Urban Services in a minute.">
      <form onSubmit={onSubmit}>
        <Stack gap="5">
          <Field id="uname" label="Username" value={uname}
                 onChange={(e) => setuname(e.target.value)} autoComplete="username" required />
          <Field id="pwd" label="Password" type="password" value={pwd}
                 onChange={(e) => setpwd(e.target.value)} autoComplete="new-password" required />
          <Field id="cnfrmpwd" label="Confirm password" type="password" value={cnfrmpwd}
                 onChange={(e) => setcnfrmpwd(e.target.value)} autoComplete="new-password" required />
          <Field id="email1" label="Email" type="email" value={email1}
                 onChange={(e) => setemail1(e.target.value)} autoComplete="email" required />
          <Field id="number" label="Phone" type="tel" value={number}
                 onChange={(e) => setnumber(e.target.value)} autoComplete="tel" required />
          <Button type="submit">Create account</Button>
          <Button type="button" variant="secondary" onClick={() => history.push("/login")}>
            Already have an account? Log in
          </Button>
        </Stack>
      </form>
    </AuthLayout>
  );
}
